import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function CreditCardsStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.6763 16.0539L13.6002 16.05H12.4C12.2032 16.05 12.0241 16.1258 11.8903 16.2498C11.7425 16.3867 11.65 16.5826 11.65 16.8C11.65 17.2142 11.9857 17.55 12.4 17.55H13.6002L13.6763 17.5461C14.0547 17.5078 14.3502 17.1884 14.3502 16.8C14.3502 16.5825 14.2575 16.3867 14.1096 16.2498C13.9933 16.1421 13.8429 16.0707 13.6763 16.0539Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M18.8003 16.05L18.8765 16.0539C19.1467 16.0813 19.3747 16.2521 19.4829 16.489C19.5262 16.5837 19.5503 16.6891 19.5503 16.8C19.5503 17.1884 19.2548 17.5077 18.8765 17.5461L18.8003 17.55H18.3497H15.9996C15.5855 17.5498 15.2496 17.2141 15.2496 16.8C15.2496 16.5826 15.3422 16.3867 15.4901 16.2498C15.6239 16.1259 15.8029 16.0501 15.9996 16.05H17.9476H18.8003Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.59961 4.94995H3.59961C3.13048 4.95016 2.75021 5.33043 2.75 5.79956V7.44995V8.79956V8.94995V15.4001V17.5914C1.87232 17.2508 1.25008 16.3982 1.25 15.4001V8.94995V7.44995V5.79956C1.25021 4.502 2.30205 3.45016 3.59961 3.44995H17.4004C18.3984 3.45011 19.2509 4.07233 19.5916 4.94995H17.4004H6.59961Z"
				fill="currentColor"
			/>
			<path
				d="M5.75 8.94995V8.79956C5.75021 8.33043 6.13048 7.95016 6.59961 7.94995H18.25H19.75H20.4004C20.8695 7.95016 21.2498 8.33042 21.25 8.79956V10.45H19.75H18.25H7.25H5.75V8.94995ZM4.25 8.94995V10.45V11.95V16.2498V17.7498V18.4001C4.25011 19.6978 5.30199 20.7495 6.59961 20.7498H20.4004C21.698 20.7495 22.7499 19.6978 22.75 18.4001V11.95V10.45V8.79956C22.7498 7.50201 21.698 6.45016 20.4004 6.44995H19.75H18.25H6.59961C5.80432 6.45008 5.10133 6.84527 4.67622 7.44995C4.40774 7.83184 4.25008 8.29729 4.25 8.79956V8.94995ZM5.75 17.7498V16.2498V11.95H7.25H18.25H19.75H21.25V18.4001C21.2499 18.8694 20.8696 19.2495 20.4004 19.2498H6.59961C6.1304 19.2495 5.75011 18.8694 5.75 18.4001V17.7498Z"
				fill="currentColor"
			/>
		</svg>
	);
}

CreditCardsStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default CreditCardsStrokeIcon;
